export enum PamStatus {
  NEW = 'new',
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}
